import { ApolloClient, ApolloLink } from '@apollo/client'
import { cache } from './cache'

import {
    makeApolloErrorLink,
    makeApolloPersistedOperationsLink,
    makeApolloHttpLink,
    makeApolloWebsocketLink,
    apolloAuthLink,
    makeApolloLink,
    makeApolloRefreshTokenLink,
} from '@docpace/shared-react-apollo-client'
import hashes from '@docpace/reception-status-graphql/dist/client-persisted.json'
import { makeGraphqlApiHttpUrl, makeGraphqlApiWsUrl } from '@docpace/shared-ts-utils'


export const makeServerHostname = () => {
    return (
        ((typeof window !== 'undefined' && window.location.hostname === 'localhost') ? 'localhost:3014' : null) ??
        (typeof window !== 'undefined' ? window.location.hostname : '')
    )
}  

export const serverHostname = makeServerHostname()
const httpLink = makeApolloHttpLink(makeGraphqlApiHttpUrl(serverHostname))
const wsLink = makeApolloWebsocketLink(makeGraphqlApiWsUrl(serverHostname))


const link = makeApolloLink(httpLink, wsLink, apolloAuthLink)

export const apolloClient = new ApolloClient({
    link: ApolloLink.from([
        makeApolloRefreshTokenLink({ serverHostname }),
        makeApolloErrorLink(),
        makeApolloPersistedOperationsLink(hashes),
        link,
    ]),
    cache,
})
